import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/auth.css";
import logoWhite from "../images/mockq-logo-light.png";

/* ------------------------------------------------------------------
   Shared building blocks for Login + Signup
   ------------------------------------------------------------------ */

export function Field({ id, label, error, hint, children }) {
  return (
    <div className={`f${error ? " bad" : ""}`}>
      {label && <label htmlFor={id}>{label}</label>}
      {children}
      {hint}
      <div className="err" role={error ? "alert" : undefined}>
        {error}
      </div>
    </div>
  );
}

export function PasswordInput({
  id,
  value,
  onChange,
  onBlur,
  autoComplete,
  maxLength,
  inputRef,
  placeholder,
}) {
  const [show, setShow] = useState(false);

  return (
    <div className="pw">
      <input
        id={id}
        ref={inputRef}
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        autoComplete={autoComplete}
        maxLength={maxLength}
        placeholder={placeholder}
      />
      <button
        type="button"
        className="eye"
        onClick={() => setShow((v) => !v)}
        aria-label={show ? "Hide password" : "Show password"}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      </button>
    </div>
  );
}

/* ------------------------------------------------------------------
   Page shell: blue side panel + card with Log in / Sign up tabs
   active = "login" | "signup"
   ------------------------------------------------------------------ */
export default function AuthLayout({ active, children }) {
  return (
    <div className="auth-page">
      <aside className="side">
        <svg className="ring" viewBox="0 0 200 200" aria-hidden="true">
          <circle cx="100" cy="100" r="70" strokeWidth="22" />
          <path d="M148 148 L184 184" strokeWidth="22" />
          <path d="M58 142 Q104 132 124 76" strokeWidth="12" />
          <polygon points="106,72 140,56 144,94" />
        </svg>

        <img src={logoWhite} alt="MockQ" />

        <div>
          <h1>Your next mock exam is waiting.</h1>
          <ul>
            <li>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z" />
                <path d="M9 12l2 2 4-4" />
              </svg>
              AI-proctored attempts you can trust
            </li>
            <li>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <rect x="3" y="4" width="18" height="13" rx="2" />
                <path d="M8 21h8M12 17v4" />
              </svg>
              An interface that matches the real exam
            </li>
            <li>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
              </svg>
              Results and progress saved after every mock
            </li>
          </ul>
        </div>

        <small>CMA USA · ACCA · EA · Classes 5 to 12</small>
      </aside>

      <main className="main">
        <div className="card">
          <div className="tabs" role="tablist">
            <Link
              to="/login"
              role="tab"
              aria-selected={active === "login"}
            >
              Log in
            </Link>
            <Link
              to="/signup"
              role="tab"
              aria-selected={active === "signup"}
            >
              Sign up
            </Link>
          </div>

          {children}

          <Link className="back" to="/">
            Back to home
          </Link>
        </div>
      </main>
    </div>
  );
}